import type { TOC } from '@ember/component/template-only';

import Default from 'umg-ember-backend/components/record-detail/for/default';

interface ActionsActionRouteSignature {
  Args: {
    model: unknown;
  };
}

<template>
  <Default @model={{@model}} />
</template> satisfies TOC<ActionsActionRouteSignature>;
